import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Chart, registerables } from 'chart.js';
import { Provider } from 'jotai';
import { OverlayProvider } from 'overlay-kit';

import { useInitSentryUserEffect } from '@/entities/auth/hooks';
import { RootRouterErrorBoundary } from '@/shared/components/root-router-error-boundary';
import { Toaster } from '@/shared/components/shadcn/sonner';
import { store } from '@/shared/store/store';
Chart.register(...registerables);

function RootComponent() {
  useInitSentryUserEffect();

  return (
    <Provider store={store}>
      <OverlayProvider>
        <Toaster theme="dark" position="bottom-center" />
        <Outlet />
      </OverlayProvider>
    </Provider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootRouterErrorBoundary,
});
